import { Button } from 'primereact/button';
import React from 'react';

export const SingleSignOnLogin = () => {
  return (
    <div className="p-fluid grid">
      <div className="field col-12 md:col-6 mb-0">
        <Button label="SSO #1" />
      </div>
      <div className="field col-12 md:col-6 mb-0">
        <Button label="SSO #2" />
      </div>
    </div>
  );
};
